import {buildContestCertificateHtml} from './contestCertificateTemplate';
import {ContestCertificateViewModel} from './certificateViewModel';

export function downloadContestCertificate(
  viewModel: ContestCertificateViewModel,
) {
  const printWindow = window.open('', '_blank');

  if (!printWindow) {
    return;
  }

  const html = buildContestCertificateHtml(viewModel).replace(
    '</body>',
    `<script>
      window.addEventListener('load', function () {
        setTimeout(function () {
          window.focus();
          window.print();
        }, 120);
      });
    </script></body>`,
  );

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
}
